import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "searchInput"]

  connect() {
    this._debounceTimer = null
  }

  debouncedSubmit() {
    clearTimeout(this._debounceTimer)
    this._debounceTimer = setTimeout(() => this.submit(), 300)
  }

  submit() {
    if (this.hasFormTarget) {
      this.formTarget.requestSubmit()
    }
  }
}
